import styled from '@emotion/styled';
import { BaseProperties, ColorVariables } from '@group-link-one/gl-ui/utilities';
import { motion } from 'framer-motion';

export const TopContentContainer = styled(motion.div)`
  height: 80px;
  width: 100%;
  background: ${ColorVariables.COLOR.COLOR_QUINARY_BACKGROUND};
  border: 1px solid ${ColorVariables.BASE.BASE_COLOR_QUINARY_STROKE};
  border-radius: ${BaseProperties.RADIUS.ML};

  padding-right: 15px;
  padding-left: 15px;
`;
